import PropTypes from 'prop-types';
import FileItem from './file_item';

const FileList = ({ 
  files, 
  currentPath, 
  selectedItems, 
  onSelectItem, 
  onItemClick, 
  onDoubleClick, 
  paneId, 
  onDropOnItem, 
  onContextMenu, 
  sortConfig, 
  onSort,
  renamingItem,
  onRenameCancel,
  onRenameSubmit
}) => {
  const isSelected = (item) => selectedItems.some(s => s.path === item.path);

  const renderSortIcon = (key) => {
    if (sortConfig?.key !== key) return null;
    return <i className={`fa fa-sort-${sortConfig.direction === 'asc' ? 'asc' : 'desc'} ml-1`} />;
  };

  if (files.length === 0) {
    return (
      <div 
        className="file-list empty"
        onContextMenu={(e) => onContextMenu(e, null)}
      >
        <div className="text-center text-muted p-5">
          <i className="fa fa-folder-open fa-3x mb-3" />
          <p>Dieser Ordner ist leer</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="file-list"
      onContextMenu={(e) => {
        // Only trigger if clicking directly on the container or table parts (not rows which handle it themselves)
        if (e.target === e.currentTarget || e.target.closest('thead')) {
           onContextMenu(e, null);
        }
      }}
    >
      <table className="table table-hover table-sm">
        <thead>
          <tr>
            <th style={{ width: '30px' }}></th>
            <th style={{ width: '30px' }}></th>
            <th onClick={() => onSort('name')} style={{ cursor: 'pointer' }}>
              Name {renderSortIcon('name')}
            </th>
            <th style={{ width: '120px', cursor: 'pointer' }} onClick={() => onSort('size')}>
              Größe {renderSortIcon('size')}
            </th>
            <th style={{ width: '100px', cursor: 'pointer' }} onClick={() => onSort('mode')}>
              Berechtigungen {renderSortIcon('mode')}
            </th>
            <th style={{ width: '180px', cursor: 'pointer' }} onClick={() => onSort('mtime')}>
              Geändert {renderSortIcon('mtime')}
            </th>
          </tr>
        </thead>
        <tbody>
          {files.map((file, index) => (
            <FileItem
              key={file.path}
              item={file}
              isSelected={isSelected(file)}
              onSelect={(selected) => onSelectItem(file, selected)}
              onItemClick={(e) => onItemClick(file, index, e)}
              onDoubleClick={() => onDoubleClick(file)}
              onContextMenu={(e) => onContextMenu(e, file)}
              paneId={paneId}
              currentPath={currentPath}
              selectedItems={selectedItems}
              onDropOnItem={onDropOnItem}
              isRenaming={renamingItem?.path === file.path}
              onRenameCancel={onRenameCancel}
              onRenameSubmit={onRenameSubmit}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

FileList.propTypes = {
  files: PropTypes.array.isRequired,
  currentPath: PropTypes.string.isRequired,
  selectedItems: PropTypes.array.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
  paneId: PropTypes.string.isRequired,
  onDropOnItem: PropTypes.func,
  onContextMenu: PropTypes.func.isRequired,
  sortConfig: PropTypes.object,
  onSort: PropTypes.func,
  renamingItem: PropTypes.object,
  onRenameCancel: PropTypes.func,
  onRenameSubmit: PropTypes.func,
};

export default FileList;